import React from 'react';
import TopBar from '../LiveVotingTopBar';
import stylesheet from './QuestionHeader.module.scss';

export default class QuestionHeader extends React.Component {
    render() {
        let {event, question, i18n} = this.props;

        return (
            <>
                <TopBar {...this.props} />
                <div className={stylesheet.QuestionHeader}>
                    <h4 className={stylesheet.text}>{question.text}</h4>
                    {question.description ? <p className="content text main">{question.description}</p> : null}
                    <hr />
                </div>
            </>
        );
    }
}
